import { IRegularInfrastructureData, ITAInfrastructureData, TTAInfrastructureType } from '../../../../types/map';

export function toRegularGeoObjects(
  infrastructureByYear: Map<number, IRegularInfrastructureData>,
  year: number,
  onlyExisting = false,
) {
  const geoObjectsData = infrastructureByYear.get(year)?.geoObjectsData || [];

  // TODO: Будет удалено при выпиле фича-флага в NB-1153.
  if (onlyExisting) {
    return geoObjectsData
      .filter(datum => !(datum.infrastructureItem && 'constructionYearFrom' in datum.infrastructureItem))
      .map(datum => datum.geoObject);
  }

  return geoObjectsData.map(datum => datum.geoObject);
}

export function toTransportAccessibilityGeoObjects(
  transportAccessibilityInfrastructureByType: Map<TTAInfrastructureType, ITAInfrastructureData>,
  infrastructureType: TTAInfrastructureType,
) {
  const geoObjectsData = transportAccessibilityInfrastructureByType.get(infrastructureType)?.geoObjectsData || [];

  return geoObjectsData.map(datum => datum.geoObject);
}
